// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultloader {
    position: absolute;
    z-index: 5;
    background-color: white !important;
    width: 95%;
    height: 100vh;
    top: 1%;
    margin-top: -100px;
    border-radius: 10px;
    background: no-repeat;
}

.loader_image {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translate(0, -50%);

}

.loader_image_inside_pop {
    position: absolute;
    top: 65%;
    left: 30%;
    right: 0;
    margin: auto;
    transform: translate(0, -50%);
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,kCAAkC;IAClC,UAAU;IACV,aAAa;IACb,OAAO;IACP,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,6BAA6B;;AAEjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,6BAA6B;AACjC","sourcesContent":[".defaultloader {\n    position: absolute;\n    z-index: 5;\n    background-color: white !important;\n    width: 95%;\n    height: 100vh;\n    top: 1%;\n    margin-top: -100px;\n    border-radius: 10px;\n    background: no-repeat;\n}\n\n.loader_image {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n    margin: auto;\n    transform: translate(0, -50%);\n\n}\n\n.loader_image_inside_pop {\n    position: absolute;\n    top: 65%;\n    left: 30%;\n    right: 0;\n    margin: auto;\n    transform: translate(0, -50%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
